import React from 'react'

import HeaderMeta from 'components/HeaderMeta'

import EmailForm from 'components/blocks/EmailForm'
import PageHero, { Theme as PageHeroTheme } from 'components/blocks/PageHero'

const InquireScreen: React.FC = (): React.ReactElement => {
  return (
    <div>
      <HeaderMeta
        title='Franchise Inquiry | Insurance Lounge'
        description='Franchise Inquiry'
      />
      <PageHero theme={PageHeroTheme.franchising}>
        Insurance Lounge Franchise Opportunity
      </PageHero>
      <EmailForm
        description=''
        postUrl='contact/franchising'
        showConcierge={false}
        showPhoneNumber={true}
        showStatesInteresetedIn={true}
        submitButtonText='Request Info Now'
        successTitle='Thank you for reaching out.'
        successDescription='Our leadership team will be in touch with you shortly.'
        title={(<>Reach out to learn more about our Insurance Lounge<sup>®</sup> franchise opportunity.</>)}
        topic='Franchising'
      />
    </div>
  )
}

export default InquireScreen
